function WebGeoLocationProvider() {
  let watchId = null;

  function start(cb, err) {
    if (!navigator || !navigator.geolocation || !navigator.geolocation.watchPosition) {
      throw Error('GeoLocation API unavailable.');
    }
    if (watchId) {
      stop();
    } // clear previous watch
    watchId = navigator.geolocation.watchPosition(
      position => {
        const { latitude, longitude, accuracy, floorLevel } = position.coords;
        cb(position.timestamp, latitude, longitude, accuracy, floorLevel, 'CoreLocation', false, position);
      },
      err,
      {
        enableHighAccuracy: true,
        timeout: 10000, // timeout in 10 seconds
      },
    );
  }

  function stop() {
    navigator.geolocation.clearWatch(watchId);
    watchId = null;
  }

  return {
    start,
    stop,
  };
}

export default WebGeoLocationProvider;
